import { HttpClient } from './HttpClient.js';


export const DatabaseService = {
    async loadSCL(request) {
        return await HttpClient.post(`/uploadFile/loadSCL`, request).then(response => response);
    },
    async loadPayments(request) {
        return await HttpClient.post(`/uploadFile/loadPayments`, request).then(response => response);
    },
    async loadCanceledAgreemets(request) {
        return await HttpClient.post(`/uploadFile/loadCanceledAgreemets`, request).then(response => response);
    },
    async loadBulkManagement (request) {
        return await HttpClient.post(`/uploadFile/loadBulkManagement`, request).then(response => response);
    },
    async loadMassiveDirections (request) {
        return await HttpClient.post(`/uploadFile/loadMassiveDirections`, request).then(response => response);
    },
    async loadTelephones (request) {
        return await HttpClient.post(`/telephone/post-load-telephone`, request).then(response => response);
    },
    async preview (request) {
        return await HttpClient.post(`/import/preview`, request).then(response => response);
    },
    async confirmImport (request) {
        return await HttpClient.postJSON(`/import/confirm`, request).then(response => response);
    },
    async listImports () {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
            return await HttpClient.get(`/import`, { signal: controller.signal });
        } finally {
            clearTimeout(timer);
        }
    },
    async getImport (id) {
        return await HttpClient.get(`/import/${id}`).then(response => response);
    },
    async getImportLogs (id) {
        return await HttpClient.get(`/import/${id}/logs`).then(response => response);
    }
}
